import type {TAPIElementFieldNames, TId} from '@/assets/core/assets/api/types';
import type {IUserAll, IUserUpdate} from '@/api/types/user';

import {userAPI} from '@/api/requesters/user';
import {userListAPI} from '@/api/requesters/userList';

const fieldNames: TAPIElementFieldNames<IUserAll> = {
  pageTitle: 'Пользователи',
  drawerTitle: 'Пользователь',

  id: 'Ид.',
  email: 'Почта',
  username: 'Логин',
  name: 'Имя',

  roles: 'Роли',
  tech_roles: 'Системные роли',
  view_roles: 'Роли (ID)',
  view_roles_map: 'Роли подразделений',

  mailing_enabled: 'Уведомления',
  created_at: 'Создан',
  updated_at: 'Обновлён',
};

const useUserControllerHook = () => {
  const updateMailingEnabled = async (value: boolean) => {
    return await userAPI.updateOne(undefined, {mailing_enabled: value});
  };

  const getUserById = async (id: TId): Promise<IUserAll> => {
    return await userAPI.getOne(id);
  };

  const updateUserRoles = async (id: TId, body: IUserUpdate) => {
    return await userAPI.updateOne(id, body);
  };

  const listApi = userListAPI.clone();

  return {
    updateMailingEnabled,
    getUserById,
    updateUserRoles,

    listApi,

    fieldNames,
  };
};

const userController = useUserControllerHook();

export default userController;
